export default "/_next/static/images/1a/article1-1a39b57d9d4414f727c8ebbc13ef39f1.jpg";